import { ErrorMessage, type ErrorMessageProps } from 'formik';

import { FieldDescription } from './ui/field';

type Props = ErrorMessageProps;

export const ErrorField = ({ name, ...props }: Props): React.ReactElement => {
  return (
    <ErrorMessage name={name} component={FieldDescription} className="text-red-600" {...props} />
  );
};
